"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetTimezoneNames = getOffsetTimezoneNames;
exports.getSingleTimezoneFromArray = getSingleTimezoneFromArray;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function recalculateOffsetToString(offset) {
    const hoursInMinutes = 60;
    const hours = Math.round(Math.abs(offset) / hoursInMinutes);
    const minutes = Math.abs(offset) % hoursInMinutes;
    const hoursString = hours.toString().length === 1 ? `0${hours}` : hours.toString();
    const minutesString = minutes.toString().length === 1 ? `0${minutes}` : minutes.toString();
    const sign = offset < 0 ? '-' : '+';
    return `${sign}${hoursString}:${minutesString}`;
}
function getOffsetTimezoneNames(offset) {
    if (!offset) {
        return;
    }
    const offsetString = recalculateOffsetToString(offset);
    return moment_timezone_1.default.tz.names().filter(tz => moment_timezone_1.default.tz(tz).format('Z') === offsetString);
}
function getSingleTimezoneFromArray(timezones) {
    const bratislavaTimezone = timezones === null || timezones === void 0 ? void 0 : timezones.find(timezone => timezone === 'Europe/Bratislava');
    return bratislavaTimezone || (timezones === null || timezones === void 0 ? void 0 : timezones[0]);
}
